import React from "react";

const Thumbs = ({ className }: { className: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 63 63"
      fill="none"
      className={className}
    >
      <g clip-path="url(#clip0_3712_5663)">
        <path
          d="M41.9349 31.6373H26.1949C25.3746 31.6373 24.6558 31.0887 24.4396 30.2974C24.2233 29.5062 24.5631 28.6681 25.2692 28.2507C32.1271 24.1984 35.6893 19.4714 36.1591 13.7996C36.323 11.8312 38.0762 10.259 40.0663 10.285C42.0971 10.3174 43.9996 11.1314 45.4245 12.5773C46.8505 14.0245 47.6364 15.9409 47.6371 17.9733C47.6371 17.9736 47.6371 17.9738 47.6371 17.9741V18.5855C47.6371 23.5503 46.1666 26.716 43.4532 30.8208C43.116 31.3307 42.546 31.6373 41.9349 31.6373Z"
          fill="#FFC380"
        />
        <path
          d="M61.2232 33.7001C61.2232 30.556 58.6653 27.998 55.5211 27.998H26.1933C25.8675 27.998 25.5475 28.0855 25.2672 28.2514C23.2085 29.4686 21.1298 30.4707 19.4596 31.2761C18.877 31.5569 18.3267 31.8222 17.8262 32.0724C17.2097 32.3807 16.8203 33.0107 16.8203 33.7001V56.9936C16.8203 57.683 17.2097 58.313 17.8262 58.6213C25.1794 62.2974 31.2917 62.7419 38.4194 62.7419C39.5232 62.7419 40.652 62.7312 41.8129 62.7203C43.0967 62.7082 44.424 62.6956 45.8156 62.6956H51.5687C54.7127 62.6956 57.2707 60.1378 57.2707 56.9936C57.2707 55.9364 56.9817 54.9456 56.4782 54.0959C58.1164 53.093 59.2118 51.2867 59.2118 49.2291C59.2118 48.1719 58.9228 47.1811 58.4193 46.3314C60.0576 45.3285 61.153 43.5221 61.153 41.4645C61.153 39.9857 60.5871 38.6366 59.6606 37.6225C60.6696 36.5591 61.2232 35.1722 61.2232 33.7001Z"
          fill="#FFCF99"
        />
        <path
          d="M57.4403 17.83H53.5581C52.5531 17.83 51.7383 17.0152 51.7383 16.0102C51.7383 15.0053 52.5531 14.1904 53.5581 14.1904H57.4403C58.4453 14.1904 59.2601 15.0053 59.2601 16.0102C59.2601 17.0152 58.4454 17.83 57.4403 17.83Z"
          fill="#29CCB1"
        />
        <path
          d="M30.2646 17.83H26.3823C25.3773 17.83 24.5625 17.0152 24.5625 16.0102C24.5625 15.0053 25.3773 14.1904 26.3823 14.1904H30.2646C31.2695 14.1904 32.0844 15.0053 32.0844 16.0102C32.0844 17.0152 31.2698 17.83 30.2646 17.83Z"
          fill="#29CCB1"
        />
        <path
          d="M36.091 7.74394C35.4619 7.74394 34.8504 7.41759 34.5134 6.8338L32.5722 3.47163C32.0697 2.60133 32.368 1.48823 33.2383 0.985815C34.1086 0.483276 35.2217 0.78153 35.7241 1.65183L37.6652 5.014C38.1677 5.8843 37.8695 6.99739 36.9992 7.49981C36.7127 7.66535 36.3997 7.74394 36.091 7.74394Z"
          fill="#29CCB1"
        />
        <path
          d="M47.7324 7.74404C47.4236 7.74404 47.1107 7.66545 46.8242 7.49992C45.9539 6.99738 45.6556 5.88441 46.1582 5.01411L48.0993 1.65194C48.6017 0.781638 49.7148 0.483142 50.5851 0.985923C51.4554 1.48846 51.7537 2.60143 51.2511 3.47174L49.31 6.8339C48.9732 7.4177 48.3614 7.74404 47.7324 7.74404Z"
          fill="#29CCB1"
        />
        <path
          d="M12.6708 53.1343V62.7186H9.03125V53.1343C9.03125 52.1298 9.84657 51.3145 10.851 51.3145C11.8555 51.3145 12.6708 52.1298 12.6708 53.1343Z"
          fill="#73C3FF"
        />
        <path
          d="M57.4403 17.83H53.5581C52.5531 17.83 51.7383 17.0152 51.7383 16.0102C51.7383 15.0053 52.5531 14.1904 53.5581 14.1904H57.4403C58.4453 14.1904 59.2601 15.0053 59.2601 16.0102C59.2601 17.0152 58.4454 17.83 57.4403 17.83Z"
          fill="#29CCB1"
        />
        <path
          d="M30.2646 17.83H26.3823C25.3773 17.83 24.5625 17.0152 24.5625 16.0102C24.5625 15.0053 25.3773 14.1904 26.3823 14.1904H30.2646C31.2695 14.1904 32.0844 15.0053 32.0844 16.0102C32.0844 17.0152 31.2698 17.83 30.2646 17.83Z"
          fill="#29CCB1"
        />
        <path
          d="M36.091 7.74394C35.4619 7.74394 34.8504 7.41759 34.5134 6.8338L32.5722 3.47163C32.0697 2.60133 32.368 1.48823 33.2383 0.985815C34.1086 0.483276 35.2217 0.78153 35.7241 1.65183L37.6652 5.014C38.1677 5.8843 37.8695 6.99739 36.9992 7.49981C36.7127 7.66535 36.3997 7.74394 36.091 7.74394Z"
          fill="#29CCB1"
        />
        <path
          d="M47.7324 7.74404C47.4236 7.74404 47.1107 7.66545 46.8242 7.49992C45.9539 6.99738 45.6556 5.88441 46.1582 5.01411L48.0993 1.65194C48.6017 0.781638 49.7148 0.483142 50.5851 0.985923C51.4554 1.48846 51.7537 2.60143 51.2511 3.47174L49.31 6.8339C48.9732 7.4177 48.3614 7.74404 47.7324 7.74404Z"
          fill="#29CCB1"
        />
        <path
          d="M12.6708 53.1343V62.7186H9.03125V53.1343C9.03125 52.1298 9.84657 51.3145 10.851 51.3145C11.8555 51.3145 12.6708 52.1298 12.6708 53.1343Z"
          fill="#73C3FF"
        />
        <path
          d="M18.6183 27.998H3.08933C2.08486 27.998 1.26953 28.8134 1.26953 29.8178V60.8757C1.26953 61.8814 2.08486 62.6955 3.08933 62.7185H14.736C16.967 62.6955 18.9021 61.4083 19.8376 59.5375C20.2222 58.772 20.4381 57.907 20.4381 56.9935V29.8178C20.4381 28.8133 19.6227 27.998 18.6183 27.998Z"
          fill="#44A4EC"
        />
        <path
          d="M12.6708 53.0127V62.7183H9.03125V53.0127C9.03125 52.0082 9.84657 51.1929 10.851 51.1929C11.8555 51.1929 12.6708 52.0082 12.6708 53.0127Z"
          fill="#73C3FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3712_5663">
          <rect
            width="62"
            height="62"
            fill="white"
            transform="translate(0.246094 0.741699)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Thumbs;
